import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { TelephoneIcon } from '@repo/ui/icons'

import useEnrollment from '../../../../lib/hooks/use-enrollment'
import ClientSpacePageTitle from '../client-space-page-title'
import HostFamilyCard from './client-enrollment-host-family-card'
import ClientFrenchManagerCard from './client-french-manager-card'

const ClientHostFamilyContactWithTransport = () => {
  const { enrollment } = useEnrollment()

  return (
    <div className="flex flex-col gap-4">
      <ClientSpacePageTitle
        icon={<TelephoneIcon color={tailwindColors.primary.dark.DEFAULT} />}
        title="Coordonnées pendant le séjour"
      />
      <HostFamilyCard enrollmentId={enrollment.id} />
      <ClientFrenchManagerCard
        enrollmentId={enrollment.id}
        center={enrollment.enrollmentCenter?.center}
      />
    </div>
  )
}

export default ClientHostFamilyContactWithTransport
